import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'unity-button-segmented',
  templateUrl: './unity-button-segmented.component.html',
  styleUrls: ['./unity-button-segmented.component.scss']
})
export class UnityButtonSegmentedComponent {
  @Input() classes = '';
  @Input() disabled = false;
}
